import React, { useCallback } from 'react';

import { FAIL_CLOSE_FIELDS } from '../../common/fields';
import * as actions from '../../containers/General/generalActions';

import ArrayContainer from '../Controls/ArrayContainer/ArrayContainer';
import Button from '../Controls/Button/Button';
import Label from '../Controls/Label/Label';
import Description from '../Controls/Description/Description';
import RangeOrSubnet from '../RangeOrSubnet/RangeOrSubnet';
import SwitchField from '../Controls/SwitchField/SwitchField';

import styles from './FailClose.module.css';

const { NON_AD_PROTOCOLS, AD_PROTOCOLS } = FAIL_CLOSE_FIELDS;

const FailClose = ({ fields, dispatch, maxSelectedSubnets, systemMode }) => {
    const nonAdProtocols = fields[NON_AD_PROTOCOLS.ID];
    const adProtocols = fields[AD_PROTOCOLS.ID];
    const dispatchUpdate = useCallback(
        (tabKey, index, fieldId, value) => {
            dispatch({
                type: actions.UPDATE_FAIL_CLOSE_FIELD,
                payload: { fieldId: tabKey, index, arrFieldId: fieldId, value }
            });
        },
        [dispatch]
    );

    const dispatchAddRangeOrSubnet = useCallback(() => {
        dispatch({ type: actions.ADD_FAIL_CLOSE_VALUE });
    }, [dispatch]);

    const dispatchRemoveRangeOrSubnet = useCallback(
        (index) => {
            dispatch({ type: actions.REMOVE_FAIL_CLOSE_VALUE, payload: index });
        },
        [dispatch]
    );

    return (
        <>
            {nonAdProtocols && (
                <div className={styles.header}>
                    <Label value={nonAdProtocols.name} />
                    <SwitchField
                        field={{ ...nonAdProtocols, name: '' }}
                        systemMode={systemMode}
                        changed={(fId, v) => dispatchUpdate(NON_AD_PROTOCOLS.ID, 0, fId, v)}
                    />
                </div>
            )}
            {adProtocols && (
                <div className={styles.header}>
                    <Label value={adProtocols.name} />
                    <div className={styles.description}>
                        <Description value={adProtocols.desc} />
                    </div>
                    {adProtocols.warning && <div className={styles.warningText}>{adProtocols.warning}</div>}
                    {adProtocols.value.map((field, index) => {
                        return (
                            <ArrayContainer
                                key={AD_PROTOCOLS.ID + index}
                                header="Fail Close"
                                topSpace={false}
                                remove={() => dispatchRemoveRangeOrSubnet(index)}>
                                <RangeOrSubnet
                                    field={field}
                                    changedFunc={(fId, val) => dispatchUpdate(AD_PROTOCOLS.ID, index, fId, val)}
                                    maxSelectedSubnets={maxSelectedSubnets}
                                />
                            </ArrayContainer>
                        );
                    })}

                    <div className={adProtocols.value.length === 0 ? styles.empty : ''}>
                        <Button onClick={dispatchAddRangeOrSubnet}>+ Add Range, IP or Subnet</Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default React.memo(FailClose);
